import { Component, Vue } from 'vue-property-decorator';
import OpusBRequest from '@/shared/service/OpusBRequest.service';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import moment from 'moment';

@Component
export default class BalanceLeave extends Vue {

    opusbRequest:OpusBRequest= new OpusBRequest();
    leaves: any[]=[];
    employeeid: number= parseInt(AccountStoreModule.context.getters.account.employeeId);

    created(){
        this.loadLeave();
    }

    loadLeave(){
        const dateNow= moment(new Date()).format('YYYY-MM-DD');

        let searchCriteria= `C_Bpartner_ID=${this.employeeid} AND dateExpired >= '${dateNow}' AND HRM_AbsenceTake_ID IN(SELECT HRM_AbsenceTake_ID FROM HRM_AbsenceTake WHERE AbsTake IN('EXL','ANL'))`;

        this.opusbRequest.get(`api/v1/models/HRM_BalanceLeave?filter=${searchCriteria}`,{})
                .then(res=> {
                    
                    let domapping= (t) => {
                        let name= t.HRM_AbsenceTake_ID.identifier.split("_")[1];
                        let amount:number= !!t.balance ? parseInt(t.balance) : 0;
                        return { name : name, amount : amount }
                    }

                    let annualLeave= res.filter(r=> r.HRM_AbsenceTake_ID.identifier.includes("ANL"))
                                .map(domapping);

                    if(annualLeave.length > 0){
                        let totalBalance= annualLeave.map(an=>an.amount).reduce((a,l)=> a + l,0);
                        this.leaves.push({
                            name : annualLeave[0].name,
                            amount : totalBalance
                        })
                    } 

                    let extraLeave= res.filter(r=>  r.HRM_AbsenceTake_ID.identifier.includes("EXL"))
                                .map(domapping);

                    if(extraLeave.length > 0){
                        let totalBalance= extraLeave.map(an=>an.amount).reduce((a,l)=> a + l,0);
                        this.leaves.push({
                            name : extraLeave[0].name,
                            amount : totalBalance
                        })
                    }
                }).catch(e=>console.log({e}));
    }
}